module.exports = "<footer id=\"idFooter\">\n    <div class=\"container-fluid\">\n        <div class=\"row\">\n            <div class=\"col-10 text-center text-footer\"><span>En caso de necesitar apoyo puede comunicarse a la línea 437 8888 en Medellín, Cali y Bogotá.  Para el resto del país 01 8000 51 8888.  SURA ©  2018.</span></div>\n            <div class=\"col-2 version\"><span class=\"text-version\">v2018-03-16 13:56g</span></div>\n        </div>\n    </div>\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/footer/footer.component.html
// module id = ./src/app/components/shared/footer/footer.component.html
// module chunks = main